// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"readers-choice-module--wrapper--2v-DQ"};